/**
 * Swiper Gallery
 * Implements Swiper.js for gallery blocks with responsive slides and navigation
 */

import { Swiper } from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

class SwiperGallery {
    constructor() {
        this.swiperInstances = [];
        this.init();
    }

    init() {
        const containers = document.querySelectorAll('.swiper-gallery-swiper');

        if (!containers.length) {
            return;
        }

        containers.forEach(container => {
            this.initSwiper(container);
        });
    }

    initSwiper(container) {
        if (!container) {
            return;
        }

        // Find navigation buttons relative to this container
        const containerParent = container.closest('.swiper-gallery-block');
        const nextButton = containerParent ? containerParent.querySelector('.swiper-gallery-nav-next') : null;
        const prevButton = containerParent ? containerParent.querySelector('.swiper-gallery-nav-prev') : null;

        // Debug: Log button detection
        if (!nextButton || !prevButton) {
            console.warn('Swiper Gallery: Navigation buttons not found', {
                containerParent,
                nextButton,
                prevButton
            });
        }

        const swiperInstance = new Swiper(container, {
            modules: [Navigation],
            slidesPerView: 'auto',
            spaceBetween: 16,
            slidesOffsetAfter: 64,
            grabCursor: true,
            simulateTouch: true,
            preventClicks: false,
            preventClicksPropagation: false,
            slideToClickedSlide: false,
            // Navigation - use specific button elements
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            }
        });

        this.swiperInstances.push(swiperInstance);
    }

    destroyAll() {
        this.swiperInstances.forEach(instance => {
            if (instance) {
                instance.destroy(true, true);
            }
        });
        this.swiperInstances = [];
    }
}

export default SwiperGallery;